<template>
  <div class="toast-container">
    {{text}}
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  components: {

  },
  data () {
    return {

    }
  }
}
</script>

<style lang="stylus" scoped>
  .toast-container
    position fixed
    left 50%
    top 50%
    transform translate(-50%, -50%)
    padding 18px 20px
    color #fff
    background rgba(0,0,0,0.7)
    border-radius 6px
    z-index 999
    white-space nowrap
</style>